import PopupComponent from './PopupComponent';

export default class LangPopup extends PopupComponent {
	constructor() {
		super({
			element: '.popup--lang',
			elements: {
				description: '.popup__main-text',
				img: '.popup__image-cover',
				btnBackToSite: '#back-to-site',
				btnChange: '#change-lang',
			},
		});
	}

	addEventListeners() {
		super.addEventListeners();
		this.elements.btnBackToSite.addEventListener('click', () => {
			this.hide();
		});
	}

	show() {
		super.show();
		this.$emit('stopScroll');
	}

	hide(startScroll = true) {
		super.hide();
		if (startScroll) this.$emit('startScroll');
	}
}
